import React,{useState,useEffect,useRef} from "react";
import './classes/EditDiscount.css';
import { configData } from "../config";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import Select from 'react-dropdown-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
 import { format, parseISO } from "date-fns";
import { Link, useNavigate,useLocation,useParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import SalespersonSidebar from "./SalespersonSidebar";



const DeleteDiscount = () => {
    
    const [isLoading, setIsLoading] = useState(true);    
    const location  = useLocation();
   
    
    var {id} = useParams();
    
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    
   
  const initialForm = { 
  // country: '',
  discount_name: '',
  machine_name: '',
  isEditing: false,
  hasCustomMachineName: false,
  start_date: '',
  start_date_obj: null,
  end_date: '',
  end_date_obj: null,
  offer_type: '',
  fixed_price: '',
  per_price: '',
  product_type: '',
  selected_plist: [],
  discount_status: '1',
  neww_coupon: '',
  existing_coupon: ''
};

const startDateRef = useRef(null);
const endDateRef = useRef(null);
     
      const [formData, setFormData] = useState(initialForm);     
      const [errors, setErrors] = useState([]);  
      const [formErrors, setFormErrors] =useState({});     
      const[success,setSuccess] = useState('');
      const [fieldErrors, setFieldErrors] = useState({});
      const [countriesList, setCountriesList] = useState([]);
      // const [selectedcountry, setSelectedCountry] = useState([{ label: 'United States', value: 'US' }]);
      const [offerType, setOfferType] = useState("0"); // "0" = $ off, "1" = % off
      const [fixedPrice, setFixedPrice] = useState("");
      const [percentage, setPercentage] = useState("");     
      const [tempMachineName, setTempMachineName] = useState("");
      const [submittedData,setSubmittedData] = useState(null);
     const [productCategories, setProductCategories] = useState([]);
    const [discountType, setDiscountType] = useState("1");

     const [searchValue, setSearchValue] = useState('');
     const [options, setOptions] = useState([]);
     const [selectedCoupon, setSelectedCoupon] = useState(null);
     const [allCoupons, setCouponList] = useState([]);

      useEffect(() => {
                   
               // Implement debouncing here if needed
               const fetchData = async () => {
                   if (searchValue.trim() === '') {
                   setOptions([]); // Clear options if search is empty
                   return;
                   }
                   try {
                   // Replace with your actual API call
                   const response = await fetch(app_url+'smwwcommercecoupon/getcouponlist?query='+searchValue);
                   const data = await response.json();
                   setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
                   } catch (error) {
                   console.error('Error fetching data:', error);
                   }
               };
           
               const handler = setTimeout(() => {
                   fetchData();
               }, 500); // Debounce for 500ms
           
               return () => {
                   clearTimeout(handler);
               };
               }, [searchValue]);
                   const renderOption = (props, option) => (
         <li {...props}>
             {option.label}
         </li>
         );
     
          const getOptionLabel = (option) => option?.label || '';

    const onChange = (event, newValue) => {
        console.log('Selected coupon:', newValue);
        setSelectedCoupon(newValue);
       
        setSearchValue(newValue ? newValue.label : ''); 
        setFormData(prev => ({
            ...prev,
            existing_coupon: newValue ? newValue.id : '',
        }));
    };
         useEffect(() => {
                  Promise.all([
                    
                     retrieveCountriesList(),
                     retrieveProductCategories(),
                     getdiscountdetails(id)
                   ])
                   .then(() => {
                   
                    setIsLoading(false);
                  })
              }, []);

           
               
         async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result); 
     }
async function retrieveProductCategories() {
    const response = await fetch(
      app_url+'smwwcommercediscount/getproductcategories',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json();

    setProductCategories(data.data.result); 
     }
     async function getdiscountdetails(id) {
        const response = await fetch(
          app_url+'smwwcommercediscount/getdiscountdetails?id='+id,
          {
            method: "GET",
      
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )           
        const responsedata = await response.json();
          if(responsedata.data.msg === "Success") {
            const updatedForm = {
              ...formData,
              // country: '',
              discount_name: responsedata.data.result.discount_name,
              machine_name: responsedata.data.result.unique_id,
              start_date: responsedata.data.result.start_date,
              end_date: responsedata.data.result.end_date,
              start_date_obj: responsedata.data.result.start_date ? parseISO(responsedata.data.result.start_date) : null,
              end_date_obj: responsedata.data.result.end_date ? parseISO(responsedata.data.result.end_date) : null,
              offer_type: responsedata.data.result.offer_type,
              fixed_price: responsedata.data.result.fixed_price,
              per_price: responsedata.data.result.per_price,
              discount_status: responsedata.data.result.status,
              id:id
            };
     
            setFormData(updatedForm);
            setFixedPrice(responsedata.data.result.fixed_price);
            setPercentage(responsedata.data.result.per_price);
            setOfferType(responsedata.data.result.offer_type);
            setDiscountType(responsedata.data.result.discount_type);
            setSavedCoupons(responsedata.data.saved_coupons);
            // if(responsedata.data.discount_relate) {
            //   setRows(responsedata.data.discount_relate);
            // }
            if (responsedata.data.discount_relate) {
          const backendRows = responsedata.data.discount_relate.map((item, index) => ({
            id: index + 1,
            productType: item.productType, // or item.product_type_id
            selectedProducts: item.selectedProducts, // or item.selected_products
            isManual: false
          }));

          setRows(backendRows);
        }

          }
           
        }
      const validateForm = () => {

  const newMessages = [];

    // if (!formData.country) newMessages.push("Country is required.");
  

  if (!formData.discount_name) {
    newMessages.push("Discount Name is required.");
  
}


  // Offer type validation
  if (offerType === "0" && !fixedPrice) {
    newMessages.push("Fixed Amount is required.");
  }
  if (offerType === "1" && !percentage) {
    newMessages.push("Percentage is required.");
  }

  if (!formData.discount_status) {
    newMessages.push("Discount Status is required.");
  }





  setErrors(newMessages);         
  return newMessages.length === 0;
     
};
// const handleDateChange = (date) => {
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//            setFormData(prev => ({ ...prev, start_date: formattedDate }));
//          };
//       const handleEndDateChange = (date) => {
       
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//             setFormData(prev => ({ ...prev, end_date: formattedDate }));
//       };
    const handleDateChange = (date, field) => {
    setFormData(prev => ({
        ...prev,
        [`${field}_obj`]: date,                   
        [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
    };     

    const validateDates = (formData) => {
    let errors = {};

  

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };
  /* const productCategories = [
  { id: 1, name: "Course", products: ["Athlete Management", "Athlete Marketing and Branding"] },
  { id: 2, name: "Agent Initiation", products: ["Agent Initiation Fee"] },
  { id: 3, name: "Scout Initiation", products: ["Scout Initiation Fee"] },
  { id: 4, name: "Miscellaneous", products: ["$124 Soccer PAyment", "$215-FGM"] },
  { id: 5, name: "Reenroll", products: ["Re-Enroll","Re-Enroll Apprenticeship"] },
  { id: 6, name: "Renewal", products: [] },
  { id: 7, name: "Conference", products: ["2019 Basketball Career Conference in Las Vegas - General","2019 Basketball Career Conference in Las Vegas - Students"] },
]; */

  const [rows, setRows] = useState([
    { id: 1, productType: "", selectedProducts: [] },
  ]);

  // const handleAddRow = () => {
  //   const newId = rows.length ? rows[rows.length - 1].id + 1 : 1;
  //   setRows([...rows, { id: newId, productType: "", selectedProducts: [] }]);
  // };
const handleAddRow = () => {
  const newId = rows.length ? rows[rows.length - 1].id + 1 : 1;
  setRows([...rows, { id: newId, productType: "", selectedProducts: [], isManual: true }]);
};

  const handleRemoveRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleProductTypeChange = (id, value) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, productType: value, selectedProducts: [] }
          : row
      )
    );
  };

  const handleSelectedProductsChange = (id, options) => {
    const selected = Array.from(options)
      .filter((opt) => opt.selected)
      .map((opt) => opt.value);
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, selectedProducts: selected } : row))
    );
  };
  const couponsList = [
  "adam25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jon25",
  "jon25", 
  "jon25",
  "jon25",   
  "jon25",
  "jon25",
  "jon25",
  "jon25",
  "robert25",
  "INDIA",
]; // Example existing coupons
const existingCouponsOptions = [
    { label: 'WELCOME10', id: 1 },
    { label: 'FREESHIP', id: 2 },
    { label: 'SUMMER25', id: 3 },
];
  const [showNew, setShowNew] = useState(false); // toggle between new/existing
  const [showExist, setShowExist] = useState(false);
  const [newCouponName, setNewCouponName] = useState('');
const [existingCoupon, setExistingCoupon] = useState('');
const [savedCoupons, setSavedCoupons] = useState([]); // Stores all added coupons
const [showCouponTable, setShowCouponTable] = useState(false);
  const [existingInput, setExistingInput] = useState("");
  const [selectedExistingCoupon, setSelectedExistingCoupon] = useState(null);
  const [filteredCoupons, setFilteredCoupons] = useState([]);

  const handleExistingInput = (e) => {
    const value = e.target.value;
    setExistingInput(value);

    const filtered = couponsList.filter((coupon) =>
      coupon.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCoupons(filtered);
  };
 
const handleChange = (e) => {
  const { name, value } = e.target;

 
  // if (name === "country") {
  //   setSelectedCountry([]);
  // }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
  
  if (name === "discount_switch") {
    setDiscountType(value);  
  }
};



 const handleSubmit = async (e) => {
  e.preventDefault();   

   const mergedFormData = {
    ...formData,
    offer_type: offerType,
    fixed_price: fixedPrice,
    per_price: percentage,
    existing_coupon: existingInput,    
    product_type: rows.map(row => row.productType),
    selected_plist: rows.map(row => row.selectedProducts),
       machine_name: formData.isEditing
      ? "discount_" + tempMachineName
      : formData.machine_name,
      existing_coupon: showExist && selectedCoupon ? selectedCoupon.id : ''
  };
    const errors = validateDates(mergedFormData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
    
    console.log("formdata",mergedFormData);
     if(validateForm()) {
      //console.log("Form Submitted Successfully!",mergedFormData);
      //alert("Check console for submitted values.");
      const response = await fetch(app_url+'smwwcommercediscount/deletediscountdetails', {
      method: 'POST',
      body: JSON.stringify(mergedFormData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
     const responsedata = await response.json();
      if(responsedata.data.msg === "Success") {
        navigate('/admin/smww-commerce/discount-list', { state: { message: responsedata.data.result } });
         
               
        }
      if(responsedata.data.msg === "Error") {
        setErrors(responsedata.data.result);
      }
     
    } else {
      window.scrollTo(0, 0);
    }
    setSubmittedData(formData);
 
   console.log("create new discount submitted formdata",mergedFormData);
};
 const handleRemove = async (coupon_id) => {
    
    const removeddata = {
      coupon_id: coupon_id,
      discount_id: id
    }
    const response = await fetch(app_url+'smwwcommercediscount/removecoupondetails', {
      method: 'POST',
      body: JSON.stringify(removeddata),
      headers: {
        'Content-Type': 'application/json',
      },
      });
     const responsedata = await response.json();
      if(responsedata.data.msg === "Success") {
        setSavedCoupons(responsedata.data.saved_coupons);
        setSuccess(responsedata.data.result);
         window.scrollTo(0, 0);
               
        }
  };
    return(
          <>
                    {isLoading ? (
                        <Loading />
                    ) : (
                <div id="main">
                     <Helmet>
                        <title>
                            Delete Discount
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="create-discount-container">
                        {errors.length > 0 && (
                          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 8px no-repeat`}}>
                          {errors.map((item, index) => {
                          return <>{item}<br /></>
                          
                        })}  
                          </div>
                        )}
                        {success && (
                          <div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
                          </div>
                          
                      
                        )}
                       <form onSubmit={handleSubmit}>  
                         {/* {discountType === "1" &&(                          
                           <div className="country-form-item">
                             <label htmlFor="country">Country</label>
                        
                            <Select 
                             
                             id="country" name="country" className='select-country smww-appn'
                             searchable={true}
                             
                             clearable={true} 
                             clearOnBlur={true} 
                            // clearOnSelect={false}
                             backspaceDelete={true} 
                             
                             style={{backgroundColor:'#ffffff', width:'87.8%', borderRadius: 5}}
                                                
                             options={countriesList} 
                             
                             onChange={(val) => {
                               if(val.length == 0) {
                                 console.log(val);
                               }
                               else{
                                 setSelectedCountry(val);
                               handleChange(
                                 { target: { value: val[0]['value'], name: 'country' } }
                               )
                               
                               }}
                             }
                            
                             values={selectedcountry}                             
                             />
                             &nbsp;&nbsp;
                            {formData.country && (
                              <span className="machine_readable">
                                Machine name: {formData.machine_name}
                               
                              </span>    

                            )}
                           </div>
                         )} */}
                           {/* {(discountType === "2" || discountType === "3") && ( */}
                           <div>
                           <div style={{ marginBottom: "20px" }}>
                          <div className="product_discount" style={{ display: "block" }}>
                            <label>
                              Discount Name <span className="form-required">*</span>
                            </label>
                            <input
                              style={{ width: "30%" }}
                              type="text"
                              className="form-text"
                              name="discount_name"
                              value={formData.discount_name}
                              
                              onChange={(e) => {
                            const value = e.target.value;
                            const machineName = "discount_" + value.toLowerCase().replace(/\s+/g, "_");

                            // Always update discount_name
                            setFormData((prev) => ({
                              ...prev,
                              discount_name: value,
                              // Only update machine_name if not manually edited
                              machine_name: !prev.hasCustomMachineName ? machineName : prev.machine_name,
                            }));

                            // Only update tempMachineName if not manually edited
                            if (!formData.hasCustomMachineName) {
                              setTempMachineName(machineName.replace("discount_", ""));
                            }
                          }}
                              disabled
                                 
                            />
                            &nbsp;&nbsp;
                            {formData.discount_name && (
                              <span className="machine_readable">
                                Machine name: {formData.machine_name}
                           
                              </span>    

                            )}
                          </div>

                          {formData.isEditing && (
                            <div className="machine_readable_name">
                              <label>
                                Machine-readable name <span className="form-required">*</span>
                              </label>
                              discount_
                               <input
                                type="text"
                               // value={formData.machine_name.replace("discount_", "")}
                                value={tempMachineName}
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   setFormData((prev) => ({
                                //     ...prev,
                                //     machine_name: "discount_" + value,
                                //     hasCustomMachineName: true,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  setTempMachineName(e.target.value); // Does not affect formData.machine_name
                                }}
                              />
                            </div>
                          )}
                        </div>


                          </div>
                           {/* )} */}
                            <div className=''>
                                <label htmlFor="start_date">Start Date:</label>
                                <DatePicker
                                ref={startDateRef}
                                // selected={formData.start_date}  
                                selected={formData.start_date_obj}                              
                                id="start_date"
                                name="start_date" 
                                // onChange={handleDateChange}
                                onChange={(date) => {
                                handleDateChange(date, "start_date");
                                setTimeout(() => {
                                    const input = startDateRef.current?.input;
                                    if (input) {
                                    const len = input.value.length;
                                    input.setSelectionRange(len, len);
                                    }
                                }, 0);
                                }}
                                className=""
                                />   
                              {formErrors.start_date && (
                                <div className="error">{formErrors.start_date}</div>
                              )}                 
                            </div>
                            <div className=''>
                                <label htmlFor="end_date">End Date:</label>
                                <DatePicker
                                ref={endDateRef}
                                // selected={formData.end_date}
                                selected={formData.end_date_obj}
                                // onChange={handleEndDateChange}
                                onChange={(date) => {
                                  handleDateChange(date, "end_date");
                                  setTimeout(() => {
                                      const input = endDateRef.current?.input;
                                      if (input) {
                                      const len = input.value.length;
                                      input.setSelectionRange(len, len);
                                      }
                                  }, 0);
                                }}
                                id="end_date"
                                name="end_date"
                                className=""
                                />  
                              {formErrors.end_date && (
                                <div className="error">{formErrors.end_date}</div>
                              )}                 
                            </div>
                            <div>
                            <label>Choose Offer Type <span class="form-required">*</span></label>
                              <table className="offer-type-table">
                              <tbody>
                                <tr>
                                  <td>
                                    <label>
                                      <input
                                        type="radio"
                                        className="offer_type"
                                        name="offer_type"
                                        value="0"
                                        checked={offerType === "0"}
                                        onChange={(e) => setOfferType(e.target.value)}
                                      />
                                      $ off
                                    </label>
                                    <br />
                                    <label>
                                      <input
                                        type="radio"
                                        className="offer_type"
                                        name="offer_type"
                                        value="1"
                                        checked={offerType === "1"}
                                        onChange={(e) => setOfferType(e.target.value)}
                                      />
                                      % off
                                    </label>
                                  </td>

                                  <td>
                                    {/* Fixed Price field */}
                                    {offerType === "0" && (
                                      <div className="fixed_price">
                                        <label>
                                          Fixed Amount <span className="form-required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-text"
                                          name="fixed_price"
                                          id="fixed_price"
                                          value={fixedPrice}
                                          onChange={(e) => setFixedPrice(e.target.value)}
                                        />{" "}
                                        USD
                                      </div>
                                    )}

                                    {/* Percentage field */}
                                    {offerType === "1" && (
                                      <div className="percentage_price">
                                        <label>
                                          Percentage <span className="form-required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-text"
                                          name="per_price"
                                          id="percentage_price"
                                          value={percentage}
                                          onChange={(e) => setPercentage(e.target.value)}
                                        />{" "}
                                        %
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                              
                            </div>
                           
                          {discountType === "2" && (
                          <div className="product_discount">
  <a href="#" onClick={(e) => { e.preventDefault(); handleAddRow(); }}>
    + Add Product
  </a>
  <table id="SelectBoxContainer">
    <tbody>
      {rows.map((row, index) => (
        <tr key={row.id}>
          <td>
            <select
              name={`product_type[${index}]`}
              value={row.productType}
              onChange={(e) => handleProductTypeChange(row.id, e.target.value)}
            >
              <option value="">-Select-</option>
              {productCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </td>
          <td>
            <select
              name={`selected_plist[${index}][]`}
              multiple
              value={row.selectedProducts}
              onChange={(e) =>
                handleSelectedProductsChange(row.id, e.target.options)
              }
            >
              <option value="ALL">All</option>
            {Object.entries(
              productCategories.find((cat) => cat.id === Number(row.productType))
                ?.products || {}
            ).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
            </select>
          </td>
          <td>
            {/* {rows.length > 1 && ( */}
            {row.isManual && (
              <button type="button" onClick={() => handleRemoveRow(row.id)}>
                Remove
              </button>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

           
    )}
                <div>
        
                <label>
                    Discount Status  <span className="form-required">*</span>
                </label>
                <select
                    id="discount_status"
                    name="discount_status"
                    value={formData.discount_status}
                    onChange={handleChange}
                >
                    <option value="1">Active</option>
                    <option value="2">Disabled</option>
                    <option value="3">Archive</option>        
                </select>
            </div>
            <div className="discount-hr">
              <hr/>
            </div>
        {/*    <div>
      <label>Coupon Condition</label>
      <div  style={{ marginBottom: "10px" }}>
        <button className="form-submit" type="button" onClick={() => {setShowNew(true);setShowExist(false)}}>
          Add New Coupon
        </button>&nbsp;&nbsp;
        <button className="form-submit" type="button" onClick={() => {setShowNew(false);setShowExist(true)}}>
          Add Existing Coupon
        </button>
      </div>

     
      {showNew && (
    <div style={{ marginTop: "10px" }}>
        <label>New Coupon Name:</label><br />
         <input type="text" name="neww_coupon" id="neww_coupon" value={formData.neww_coupon} onChange={handleChange}/>
       
    </div>
)}
{showExist && (
    <div style={{ marginTop: "10px" }}>
        <label>Select Existing Coupon:</label><br />
       
           <Autocomplete
                       id="existing_coupon"
                       disablePortal
                       options={options}
                       sx={{ 
                           width: "50%", 
                           backgroundColor:"#fff",
                           border: "1px solid #ccc",
                           // maxHeight: "20px" 
                           display: "inline-block"
                       }}
                       renderOption={renderOption}
                       getOptionLabel={getOptionLabel}
                       onChange={onChange}
                       value={selectedCoupon}
                       inputValue={searchValue}
                       onInputChange={(event, newInputValue) => setSearchValue(newInputValue)}
                       renderInput={(params) => (
                           <TextField {...params} />
                       )}
                   />
    </div>
)}
 */}

    <table style={{ marginTop: "20px", fontSize: "14px", width: "90%",textAlign:"left"}}>
        <thead>
            <tr>
                <th style={{ width: "70%" }}>Coupon Name</th>
                
            </tr>
        </thead>
        {savedCoupons.length > 0 && (
        <tbody>
            {savedCoupons.map((coupon, index) => (
                <tr key={index}>
                    <td>{coupon.name}</td>
                    
                </tr>
            ))}
        </tbody>
        )}
    </table>

    {/* </div> */}
                        
                           {/* <input type="submit" value="Save Discount" className="form-submit"  /> */}
                           <input
                              type="submit"
                              value="Delete Discount"
                              className="form-submit"
                              style={{marginTop:"20px"}}
                             
                            />

                            </form>
                        </div>

                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                    </div>
                    )}
                    </>
    );
};

export default DeleteDiscount;